/**
 * Zeus product page (sections/zeus-product-main.liquid)
 * Variant UI, gallery, add to cart + checkout aligned with product.liquid / PubSub.
 */
(function () {
  var ZEUS_CART_LIMIT = 10;

  function setCartItemCount(count) {
    var safeCount = Math.max(0, parseInt(count, 10) || 0);
    if (typeof window !== "undefined") {
      window.zeusCartItemCount = safeCount;
    }
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = String(safeCount);
    });
    return safeCount;
  }

  function openOrderLimitPopup() {
    if (
      typeof window !== "undefined" &&
      window.zeusOrderLimitPopup &&
      typeof window.zeusOrderLimitPopup.open === "function"
    ) {
      window.zeusOrderLimitPopup.open();
    }
  }

  function fetchCartState() {
    return fetch("/cart.js", {
      method: "GET",
      headers: { Accept: "application/json" },
    }).then(function (r) {
      if (!r.ok) throw new Error("Could not read cart");
      return r.json();
    });
  }

  function addToCartWithLimit(variantId, requestedQty) {
    var qty = Math.max(1, parseInt(requestedQty, 10) || 1);
    return fetchCartState().then(function (cart) {
      var currentCount = setCartItemCount(cart && cart.item_count);
      var remaining = Math.max(0, ZEUS_CART_LIMIT - currentCount);
      var allowedQty = Math.min(qty, remaining);
      var wasClamped = allowedQty < qty;

      if (allowedQty <= 0) {
        openOrderLimitPopup();
        return {
          skipped: true,
          wasClamped: true,
          addedQty: 0,
          cartCount: currentCount,
        };
      }

      return fetch(cartAddUrl(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: allowedQty }],
        }),
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok)
              throw new Error(
                (data && data.description) || "Add to cart failed"
              );
            return data;
          });
        })
        .then(function (addData) {
          return fetchCartState()
            .then(function (updatedCart) {
              var updatedCount = setCartItemCount(
                updatedCart && updatedCart.item_count
              );
              if (wasClamped) openOrderLimitPopup();
              return {
                skipped: false,
                wasClamped: wasClamped,
                addedQty: allowedQty,
                cartCount: updatedCount,
                addData: addData,
              };
            })
            .catch(function () {
              if (wasClamped) openOrderLimitPopup();
              return {
                skipped: false,
                wasClamped: wasClamped,
                addedQty: allowedQty,
                addData: addData,
              };
            });
        });
    });
  }

  function readMoneyFormat(root) {
    var el = root.querySelector("[data-zeus-money-format]");
    var fallback = "\x7b\x7bamount\x7d\x7d";
    if (!el) return fallback;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return fallback;
    }
  }

  function readAtcI18n(root) {
    var el = root.querySelector("[data-zeus-atc-i18n]");
    if (!el)
      return {
        add: "Add to cart",
        adding: "Adding…",
        soldOut: "Sold out",
        off: "OFF",
      };
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return {
        add: "Add to cart",
        adding: "Adding…",
        soldOut: "Sold out",
        off: "OFF",
      };
    }
  }

  function formatMoney(cents, root) {
    var fromDom = readMoneyFormat(root);
    if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
      var f =
        (typeof window !== "undefined" &&
          window.money_without_trailing_zeros_format) ||
        (typeof window !== "undefined" && window.moneyWithoutZerosFormat) ||
        fromDom ||
        (typeof window !== "undefined" && window.money_format) ||
        "{{amount}}";
      return Shopify.formatMoney(cents, f);
    }
    return (cents / 100).toFixed(0);
  }

  function findVariant(product, selections) {
    var opts = product.options || [];
    return (product.variants || []).find(function (variant) {
      return opts.every(function (_, i) {
        return String(variant.options[i]) === String(selections[i]);
      });
    });
  }

  function getVariantImageSrc(variant) {
    if (!variant) return null;
    if (variant.featured_image && variant.featured_image.src) {
      var u0 = variant.featured_image.src;
      return u0 + (u0.indexOf("?") >= 0 ? "&" : "?") + "width=1200";
    }
    if (variant.featured_media && variant.featured_media.src) {
      var u1 = variant.featured_media.src;
      return u1 + (u1.indexOf("?") >= 0 ? "&" : "?") + "width=1200";
    }
    if (
      variant.featured_media &&
      variant.featured_media.preview_image &&
      variant.featured_media.preview_image.src
    ) {
      var u2 = variant.featured_media.preview_image.src;
      return u2 + (u2.indexOf("?") >= 0 ? "&" : "?") + "width=1200";
    }
    return null;
  }

  function getFeaturedMediaId(variant) {
    if (!variant) return null;
    if (variant.featured_media && variant.featured_media.id)
      return String(variant.featured_media.id);
    if (variant.featured_image && variant.featured_image.id)
      return String(variant.featured_image.id);
    return null;
  }

  /** Product media / JSON may use GID or plain digits; compare by numeric id. */
  function zeusDigitsFromMediaId(v) {
    if (v == null || v === "") return null;
    var s = String(v);
    if (/^\d+$/.test(s)) return s;
    var m = s.match(/(\d{3,})/g);
    return m && m.length ? m[m.length - 1] : s;
  }

  function zeusImageUrlsLooselyEqual(a, b) {
    if (!a || !b) return false;
    a = String(a).split("?")[0];
    b = String(b).split("?")[0];
    if (a === b) return true;
    var last = function (u) {
      var i = u.lastIndexOf("/");
      return i >= 0 ? u.slice(i + 1) : u;
    };
    if (last(a) && last(a) === last(b)) return true;
    return false;
  }

  function getUndershirtStyleConfig(product) {
    if (!product) return null;
    var names = product.options || [];
    var idx = -1;
    for (var i = 0; i < names.length; i++) {
      if (String(names[i] || "").trim().toLowerCase() === "undershirt style") {
        idx = i;
        break;
      }
    }
    if (idx < 0) return null;
    var seen = {};
    var values = [];
    (product.variants || []).forEach(function (v) {
      var raw = v && v.options ? v.options[idx] : null;
      var tok = String(raw || "").trim().toLowerCase();
      if (!tok) return;
      if (seen[tok]) return;
      seen[tok] = true;
      values.push(tok);
    });
    return {
      index: idx,
      values: values,
      enabled: values.length >= 2,
    };
  }

  function applyUndershirtStyleGalleryFilter(root, variant, cfg) {
    var thumbs = Array.prototype.slice.call(
      root.querySelectorAll("[data-zeus-thumb]")
    );
    if (!thumbs.length) return thumbs;
    if (!cfg || !cfg.enabled || !variant || !variant.options) {
      thumbs.forEach(function (thumb) {
        thumb.style.display = "";
        thumb.removeAttribute("hidden");
      });
      return thumbs;
    }
    var selected = String(variant.options[cfg.index] || "")
      .trim()
      .toLowerCase();
    var values = cfg.values || [];
    var visible = [];
    thumbs.forEach(function (thumb) {
      var altRaw =
        thumb.getAttribute("data-alt-lower") ||
        (thumb.getAttribute("aria-label") || "").toLowerCase();
      var alt = String(altRaw || "").toLowerCase();
      var hasAnyStyle = values.some(function (v) {
        return v && alt.indexOf(v) >= 0;
      });
      var show = !hasAnyStyle;
      if (!show && selected) {
        show = alt.indexOf(selected) >= 0;
      }
      thumb.style.display = show ? "" : "none";
      if (show) {
        thumb.removeAttribute("hidden");
        visible.push(thumb);
      } else {
        thumb.setAttribute("hidden", "hidden");
      }
    });
    return visible;
  }

  function ensureMainImageEl(root, sid) {
    var main = root.querySelector("[id^='MainImage-']");
    if (main) return main;
    var wrap = root.querySelector(".gallery-main");
    if (!wrap || !sid) return null;
    main = document.createElement("img");
    var secId = sid.id.replace("VariantId-", "");
    main.id = "MainImage-" + secId;
    main.width = 900;
    main.height = 1200;
    main.loading = "eager";
    var ph = wrap.querySelector(".gallery-main-placeholder");
    if (ph) ph.remove();
    wrap.appendChild(main);
    return main;
  }

  /**
   * Sync main image + active thumb to the current variant (initial + on change).
   * Matches by media id (with GID/number normalization), then by image URL, then first media.
   */
  function syncProductGallery(root, product, variant, optEl) {
    if (!variant) return;
    var sid = root.querySelector("[id^='VariantId-']");
    if (!sid) return;
    var dataImg = optEl && optEl.getAttribute("data-img");
    var src = dataImg || getVariantImageSrc(variant);
    var main = ensureMainImageEl(root, sid);
    var styleCfg = getUndershirtStyleConfig(product);
    var styleFilteringActive = !!(styleCfg && styleCfg.enabled);
    var allThumbs = Array.prototype.slice.call(
      root.querySelectorAll("[data-zeus-thumb]")
    );
    var visibleThumbs = applyUndershirtStyleGalleryFilter(root, variant, styleCfg);
    var firstThumb = visibleThumbs[0] || allThumbs[0] || null;
    var wantId =
      (optEl && optEl.getAttribute("data-featured-media-id")) ||
      getFeaturedMediaId(variant);
    var match = null;
    var i;

    if (visibleThumbs && visibleThumbs.length) {
      if (wantId) {
        var d2 = zeusDigitsFromMediaId(String(wantId));
        for (i = 0; i < visibleThumbs.length; i++) {
          var mid = visibleThumbs[i].getAttribute("data-media-id");
          if (mid && zeusDigitsFromMediaId(mid) === d2) {
            match = visibleThumbs[i];
            break;
          }
        }
      }
      if (!match && dataImg) {
        for (i = 0; i < visibleThumbs.length; i++) {
          if (zeusImageUrlsLooselyEqual(
            visibleThumbs[i].getAttribute("data-src"),
            dataImg
          )) {
            match = visibleThumbs[i];
            break;
          }
        }
      }
      if (!match && src) {
        for (i = 0; i < visibleThumbs.length; i++) {
          if (zeusImageUrlsLooselyEqual(
            visibleThumbs[i].getAttribute("data-src"),
            src
          )) {
            match = visibleThumbs[i];
            break;
          }
        }
      }
    }

    if (main) {
      if (match) {
        var msrc = match.getAttribute("data-src");
        if (msrc) main.setAttribute("src", msrc);
        else if (src) main.setAttribute("src", src);
      } else if (src && !styleFilteringActive) {
        main.setAttribute("src", src);
      } else if (firstThumb) {
        var fsrc = firstThumb.getAttribute("data-src");
        if (fsrc) {
          main.setAttribute("src", fsrc);
          match = firstThumb;
        }
      }
    }

    for (i = 0; i < allThumbs.length; i++) {
      allThumbs[i].classList.toggle("active", !!match && allThumbs[i] === match);
    }
  }

  function optionValuePossible(product, selections, optionIndex, value) {
    return (product.variants || []).some(function (variant) {
      if (!variant.available) return false;
      return variant.options.every(function (opt, idx) {
        if (idx === optionIndex) return String(opt) === String(value);
        return (
          selections[idx] == null ||
          selections[idx] === undefined ||
          String(opt) === String(selections[idx])
        );
      });
    });
  }

  function updateOptionAvailability(root, product, selections) {
    var optCount = (product.options || []).length;
    if (optCount < 2) return;
    root.querySelectorAll("[data-zeus-opt]").forEach(function (btn) {
      if (btn.getAttribute("data-perma-disabled") === "true") return;
      var idx = parseInt(btn.getAttribute("data-opt-idx"), 10);
      var val = btn.getAttribute("data-opt-val");
      var possible = optionValuePossible(product, selections, idx, val);
      btn.classList.toggle("zeus-opt--muted", !possible);
    });
  }

  function updateOptionLabels(root, variant) {
    if (!variant || !variant.options) return;
    variant.options.forEach(function (optVal, i) {
      var el = root.querySelector(
        '.zeus-variant-option-value[data-opt-idx="' + i + '"]'
      );
      if (el) el.textContent = optVal;
    });
  }

  function syncModalBodyScroll() {
    var quickAddModal = document.getElementById("quick-add-modal");
    var quickAddOpen = quickAddModal && quickAddModal.style.display === "flex";
    if (quickAddOpen) {
      document.body.style.overflow = "hidden";
      return;
    }
    var any =
      document.querySelector(".zeus-product-main [data-sg-overlay].active") ||
      document.querySelector(".zeus-product-main [data-sf-overlay].active");
    document.body.style.overflow = any ? "hidden" : "";
  }

  function cartAddUrl() {
    if (typeof window.routes !== "undefined" && window.routes.cart_add_url) {
      return window.routes.cart_add_url + ".js";
    }
    return "/cart/add.js";
  }

  function publishSafe(eventName, payload) {
    if (typeof publish === "function" && eventName) {
      try {
        publish(eventName, payload);
      } catch (e) {}
    }
  }

  function getSelectedOfferMultiplier(root) {
    var selectedOffer = root.querySelector(
      'input[name="zeus_custom_offer"]:checked'
    );
    if (!selectedOffer) return 1;
    var offerQty = parseInt(
      selectedOffer.getAttribute("data-offer-qty") || "1",
      10
    );
    if (!offerQty || offerQty < 1) return 1;
    return offerQty;
  }

  function getSelectedOfferUnitPriceCents(root, variant) {
    var selectedOffer = root.querySelector(
      'input[name="zeus_custom_offer"]:checked'
    );
    if (!selectedOffer) return variant && variant.price ? variant.price : 0;
    var offerCard = selectedOffer.closest(".zeus-offer-card");
    var offerLine =
      offerCard && offerCard.querySelector("[data-zeus-offer-line]");
    if (!offerLine) return variant && variant.price ? variant.price : 0;
    var custom = parseInt(
      offerLine.getAttribute("data-custom-total-cents") || "0",
      10
    );
    if (custom > 0) return custom;
    var offerQty =
      parseInt(offerLine.getAttribute("data-offer-qty") || "1", 10) || 1;
    var base = variant && variant.price ? variant.price : 0;
    return base * Math.max(1, offerQty);
  }

  /**
   * Maps form values to the guide: slim/regular = standard; comfort/loose = one size up.
   * @param {string} v
   * @returns {"slim"|"comfort"}
   */
  function normalizeZeusSfFit(v) {
    var u = String(v || "slim")
      .trim()
      .toLowerCase();
    if (u === "comfort" || u === "loose") return "comfort";
    return "slim";
  }

  function zeusSizeFinderToken(s) {
    if (s == null) return "";
    return String(s)
      .trim()
      .replace(/\u00a0/g, " ")
      .replace(/[\s\-_]/g, "")
      .toUpperCase();
  }

  function zeusSizeFinderCanonical(t) {
    if (!t) return "";
    var u = zeusSizeFinderToken(t);
    if (u === "XSMALL" || u === "EXTRASMALL") return "XS";
    if (u === "XXL") return "2XL";
    if (u === "XXXXL" || u === "XXXXXL") return "4XL";
    return u;
  }

  function zeusSizeFinderMatchesButton(btn, recommended) {
    var raw =
      btn.getAttribute("data-opt-val") || (btn.textContent || "").trim() || "";
    var a = zeusSizeFinderCanonical(raw);
    var b = zeusSizeFinderCanonical(recommended);
    return a !== "" && b !== "" && a === b;
  }

  function getPrimarySizeRow(root) {
    return (
      root.querySelector('[data-option-kind="size"]') ||
      root.querySelector('[data-option-type="size"]')
    );
  }

  function init(root) {
    if (!root || root.dataset.zeusProductBound === "true") return;
    root.dataset.zeusProductBound = "true";
    var jsonEl = root.querySelector("[data-zeus-product-json]");
    if (!jsonEl) return;
    var product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }
    var sid = root.querySelector("[id^='VariantId-']");
    if (!sid) return;
    var selections = [];
    var initV = product.selected_or_first_available_variant;
    if (!initV && sid && sid.value) {
      initV = (product.variants || []).find(function (x) {
        return String(x.id) === String(sid.value);
      });
    }
    if (!initV && (product.variants || [])[0]) {
      initV = product.variants[0];
    }
    if (initV && initV.options) selections = initV.options.slice();

    var detailsRoot = root.querySelector(".product-details-section");
    var i18n = readAtcI18n(root);
    var currentVariant = initV || null;

    function updateAtcLabelPrice() {
      var atc = root.querySelector("[data-zeus-atc-label]");
      if (!atc || !currentVariant) return;
      if (!currentVariant.available && i18n.soldOut) {
        atc.textContent = i18n.soldOut;
        return;
      }
      var qtyInput = root.querySelector(".qty-value-input");
      var qty = Math.max(1, parseInt((qtyInput && qtyInput.value) || "1", 10) || 1);
      var unitCents = getSelectedOfferUnitPriceCents(root, currentVariant);
      atc.textContent =
        (atc.getAttribute("data-add-text") || i18n.add) +
        " — " +
        formatMoney(unitCents * qty, root);
    }

    function updateVariantUi(variant, opts) {
      opts = opts || {};
      if (!variant) return;
      var optEl = null;
      for (var i = 0; i < sid.options.length; i++) {
        if (sid.options[i].value === String(variant.id)) {
          optEl = sid.options[i];
          break;
        }
      }
      syncProductGallery(root, product, variant, optEl);

      var pr = root.querySelector("[data-zeus-price]");
      var cmp = root.querySelector("[data-zeus-compare]");
      var disc = root.querySelector("[data-zeus-discount]");
      if (pr) pr.textContent = formatMoney(variant.price, root);
      if (cmp) {
        if (
          variant.compare_at_price &&
          variant.compare_at_price > variant.price
        ) {
          cmp.style.display = "";
          cmp.textContent = formatMoney(variant.compare_at_price, root);
          if (disc) {
            disc.style.display = "";
            var pct = Math.round(
              ((variant.compare_at_price - variant.price) * 100) /
                variant.compare_at_price
            );
            disc.textContent = pct + "% " + (i18n.off || "OFF");
          }
        } else {
          cmp.style.display = "none";
          if (disc) disc.style.display = "none";
        }
      }
      currentVariant = variant;
      updateAtcLabelPrice();

      root
        .querySelectorAll(".zeus-offer-card__price[data-zeus-offer-line]")
        .forEach(function (el) {
          var custom = el.getAttribute("data-custom-total-cents");
          if (custom != null && custom !== "" && parseInt(custom, 10) > 0) {
            el.textContent = formatMoney(parseInt(custom, 10), root);
            return;
          }
          var oq = parseInt(el.getAttribute("data-offer-qty") || "1", 10) || 1;
          el.textContent = formatMoney(variant.price * oq, root);
        });
      root
        .querySelectorAll(".zeus-offer-card__compare[data-zeus-offer-compare]")
        .forEach(function (el) {
          var ccf = el.getAttribute("data-custom-compare-cents");
          if (ccf != null && ccf !== "" && parseInt(ccf, 10) > 0) {
            el.textContent = formatMoney(parseInt(ccf, 10), root);
            el.style.display = "";
            return;
          }
          var oq2 = parseInt(el.getAttribute("data-offer-qty") || "1", 10) || 1;
          if (
            variant.compare_at_price &&
            variant.compare_at_price > variant.price
          ) {
            el.textContent = formatMoney(variant.compare_at_price * oq2, root);
            el.style.display = "";
          } else {
            el.style.display = "none";
          }
        });

      updateOptionLabels(root, variant);

      var addBtn = root.querySelector(".add-to-cart[type='submit']");
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.classList.toggle("add-to-cart--sold-out", !variant.available);
      }
      var buyNow = root.querySelector("[data-zeus-buy-now]");
      if (buyNow) buyNow.disabled = !variant.available;

      if (!root.closest || !root.closest("#quick-add-modal-content")) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set("variant", String(variant.id));
          window.history.replaceState({}, "", url.toString());
        } catch (e2) {}
      }

      if (!opts.skipAvailability) {
        updateOptionAvailability(root, product, selections);
      }
    }

    function setVariantFromOptions(variant) {
      if (!variant) return;
      sid.value = String(variant.id);
      updateVariantUi(variant, { skipAvailability: true });
      updateOptionAvailability(root, product, selections);
    }

    var sfI18n = {};
    var sfI18nElRoot = root.querySelector("[data-zeus-sf-i18n]");
    if (sfI18nElRoot && sfI18nElRoot.textContent) {
      try {
        sfI18n = JSON.parse(sfI18nElRoot.textContent);
      } catch (eSfI18n) {
        sfI18n = {};
      }
    }

    var sgEl = root.querySelector("[data-sg-overlay]");
    var sfEl = root.querySelector("[data-sf-overlay]");
    if (sgEl) {
      sgEl.addEventListener("click", function (e) {
        if (e.target === sgEl) {
          sgEl.classList.remove("active");
          syncModalBodyScroll();
        }
      });
    }
    if (sfEl) {
      sfEl.addEventListener("click", function (e) {
        if (e.target === sfEl) {
          sfEl.classList.remove("active");
          syncModalBodyScroll();
        }
      });
    }
    root.querySelectorAll("[data-sg-close]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        var o = root.querySelector("[data-sg-overlay]");
        if (o) o.classList.remove("active");
        syncModalBodyScroll();
      });
    });
    root.querySelectorAll("[data-sf-close]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        var o = root.querySelector("[data-sf-overlay]");
        if (o) o.classList.remove("active");
        syncModalBodyScroll();
      });
    });

    root.addEventListener("click", function (e) {
      var t = e.target;
      if (!t.closest || !root.contains(t)) return;

      var openSg = t.closest("[data-open-sg]");
      if (openSg) {
        e.preventDefault();
        if (sgEl) {
          sgEl.classList.add("active");
          syncModalBodyScroll();
        }
        return;
      }

      var openSf = t.closest("[data-open-sf]");
      if (openSf) {
        e.preventDefault();
        if (sfEl) {
          sfEl.classList.add("active");
          var ids = ["sfHeight-", "sfWeight-"];
          for (var zi = 0; zi < ids.length; zi++) {
            var inp = root.querySelector("[id^='" + ids[zi] + "']");
            if (inp) inp.value = "";
          }
          var fitInp = root.querySelector("[data-sf-fit], [id^='sfFit-']");
          if (fitInp) {
            var slimOpt = fitInp.querySelector('option[value="slim"]');
            if (slimOpt) {
              fitInp.value = "slim";
            } else {
              fitInp.selectedIndex = 0;
            }
          }
          recSize = "";
          var sfFormOpen = root.querySelector("[data-sf-form]");
          var sfResultOpen = root.querySelector("[data-sf-result]");
          if (sfFormOpen) sfFormOpen.style.display = "block";
          if (sfResultOpen) {
            sfResultOpen.classList.remove("active");
            sfResultOpen.setAttribute("hidden", "hidden");
          }
          syncModalBodyScroll();
        }
        return;
      }

      var thumb = t.closest("[data-zeus-thumb]");
      if (thumb && root.contains(thumb)) {
        e.preventDefault();
        var src = thumb.getAttribute("data-src");
        if (!src) return;
        var main = root.querySelector("[id^='MainImage-']");
        var wrap = root.querySelector(".gallery-main");
        if (!main && wrap) {
          main = document.createElement("img");
          var secId = sid.id.replace("VariantId-", "");
          main.id = "MainImage-" + secId;
          main.width = 900;
          main.height = 1200;
          main.loading = "eager";
          var ph = wrap.querySelector(".gallery-main-placeholder");
          if (ph) ph.remove();
          wrap.appendChild(main);
        }
        if (main) main.setAttribute("src", src);
        root.querySelectorAll("[data-zeus-thumb]").forEach(function (x) {
          x.classList.remove("active");
        });
        thumb.classList.add("active");
        return;
      }

      var tabBtn = t.closest(".details-tab[data-tab]");
      if (tabBtn && detailsRoot && detailsRoot.contains(tabBtn)) {
        e.preventDefault();
        var tid = tabBtn.getAttribute("data-tab");
        var vid = sid.id.replace("VariantId-", "");
        detailsRoot.querySelectorAll(".details-tab").forEach(function (x) {
          x.classList.toggle("active", x === tabBtn);
        });
        detailsRoot.querySelectorAll(".tab-content").forEach(function (p) {
          p.classList.remove("active");
        });
        var panel = detailsRoot.querySelector("#tab-" + tid + "-" + vid);
        if (panel) panel.classList.add("active");
        return;
      }

      var optBtn = t.closest("[data-zeus-opt]");
      /* zeus-opt--muted is visual-only; still clickable to reach other combos */
      if (
        optBtn &&
        root.contains(optBtn) &&
        optBtn.getAttribute("data-perma-disabled") !== "true"
      ) {
        e.preventDefault();
        var idx = parseInt(optBtn.getAttribute("data-opt-idx"), 10);
        var val = optBtn.getAttribute("data-opt-val");
        var row = root.querySelector('[data-option-row="' + idx + '"]');
        if (row) {
          row.querySelectorAll("[data-zeus-opt]").forEach(function (b) {
            b.classList.remove("active");
            b.setAttribute("aria-pressed", "false");
          });
        }
        optBtn.classList.add("active");
        optBtn.setAttribute("aria-pressed", "true");
        selections[idx] = val;
        var v = findVariant(product, selections);
        if (v) setVariantFromOptions(v);
      }
    });

    sid.addEventListener("change", function () {
      var id = parseInt(sid.value, 10);
      var v = (product.variants || []).find(function (x) {
        return String(x.id) === String(id);
      });
      if (v) {
        (v.options || []).forEach(function (optVal, i) {
          var row = root.querySelector('[data-option-row="' + i + '"]');
          if (!row) return;
          row.querySelectorAll("[data-zeus-opt]").forEach(function (b) {
            var match = b.getAttribute("data-opt-val") === String(optVal);
            b.classList.toggle("active", match);
            b.setAttribute("aria-pressed", match ? "true" : "false");
          });
        });
        selections = (v.options || []).slice();
        updateVariantUi(v);
      }
    });

    root.querySelectorAll("[data-qty]").forEach(function (b) {
      b.addEventListener("click", function () {
        var inp = root.querySelector(".qty-value-input");
        if (!inp) return;
        var d = parseInt(b.getAttribute("data-qty"), 10);
        var n = Math.max(1, (parseInt(inp.value, 10) || 1) + d);
        inp.value = String(n);
        updateAtcLabelPrice();
      });
    });
    var qtyInputEl = root.querySelector(".qty-value-input");
    if (qtyInputEl) {
      qtyInputEl.addEventListener("input", function () {
        var n = Math.max(1, parseInt(qtyInputEl.value || "1", 10) || 1);
        if (String(n) !== String(qtyInputEl.value || "")) {
          qtyInputEl.value = String(n);
        }
        updateAtcLabelPrice();
      });
      qtyInputEl.addEventListener("change", function () {
        var n = Math.max(1, parseInt(qtyInputEl.value || "1", 10) || 1);
        qtyInputEl.value = String(n);
        updateAtcLabelPrice();
      });
    }
    root
      .querySelectorAll('input[name="zeus_custom_offer"]')
      .forEach(function (offerInput) {
        offerInput.addEventListener("change", function () {
          updateAtcLabelPrice();
        });
      });

    function applyUrlVariantOnLoad() {
      if (root.closest && root.closest("#quick-add-modal-content")) return;
      try {
        var params = new URLSearchParams(window.location.search);
        var vid = params.get("variant");
        if (!vid) return;
        var v = (product.variants || []).find(function (x) {
          return String(x.id) === String(vid);
        });
        if (v) {
          selections = (v.options || []).slice();
          sid.value = String(v.id);
          (v.options || []).forEach(function (optVal, i) {
            var row = root.querySelector('[data-option-row="' + i + '"]');
            if (!row) return;
            row.querySelectorAll("[data-zeus-opt]").forEach(function (b) {
              var match = b.getAttribute("data-opt-val") === String(optVal);
              b.classList.toggle("active", match);
              b.setAttribute("aria-pressed", match ? "true" : "false");
            });
          });
          updateVariantUi(v);
        }
      } catch (e3) {}
    }

    if (initV) {
      updateVariantUi(initV, { skipAvailability: true });
      updateOptionAvailability(root, product, selections);
    }
    applyUrlVariantOnLoad();

    var formEl = root.querySelector("form.zeus-product-form");
    fetchCartState()
      .then(function (cart) {
        setCartItemCount(cart && cart.item_count);
      })
      .catch(function () {});

    if (formEl) {
      formEl.addEventListener("submit", function (e) {
        e.preventDefault();
        var submitBtn = formEl.querySelector(
          '.add-to-cart[type="submit"][name="add"]'
        );
        var fd = new FormData(formEl);
        var variantId = fd.get("id");
        var qty = parseInt(fd.get("quantity") || "1", 10) || 1;
        var offerMultiplier = getSelectedOfferMultiplier(root);
        qty = Math.max(1, qty * offerMultiplier);
        fd.set("quantity", String(qty));
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.setAttribute("aria-busy", "true");
          submitBtn.classList.add("add-to-cart--loading");
        }
        addToCartWithLimit(variantId, qty)
          .then(function (result) {
            if (!result || result.skipped) return;
            if (typeof PUB_SUB_EVENTS !== "undefined") {
              publishSafe(PUB_SUB_EVENTS.cartUpdate, {
                action: "add",
                variant: result.addData,
                formData: Object.fromEntries(fd),
                product: product,
              });
            }
          })
          .catch(function (err) {
            if (typeof PUB_SUB_EVENTS !== "undefined") {
              publishSafe(PUB_SUB_EVENTS.cartError, {
                error: err.message,
                context: "add-to-cart",
                productId: product.id,
              });
            }
            alert(err.message || "Could not add to cart");
          })
          .finally(function () {
            if (submitBtn) {
              submitBtn.classList.remove("add-to-cart--loading");
              submitBtn.setAttribute("aria-busy", "false");
              var lab = submitBtn.querySelector("[data-zeus-atc-label]");
              var cur = (product.variants || []).find(function (x) {
                return String(x.id) === String(sid.value);
              });
              if (cur) {
                currentVariant = cur;
                submitBtn.disabled = !cur.available;
                submitBtn.classList.toggle(
                  "add-to-cart--sold-out",
                  !cur.available
                );
                if (lab) updateAtcLabelPrice();
              } else {
                submitBtn.disabled = false;
              }
            }
          });
      });
    }

    var buyNowBtn = root.querySelector("[data-zeus-buy-now]");
    if (buyNowBtn && formEl) {
      buyNowBtn.addEventListener("click", function () {
        if (buyNowBtn.disabled) return;
        var fd = new FormData(formEl);
        var baseQty = parseInt(fd.get("quantity") || "1", 10) || 1;
        var offerMultiplier = getSelectedOfferMultiplier(root);
        var finalQty = Math.max(1, baseQty * offerMultiplier);
        buyNowBtn.disabled = true;
        addToCartWithLimit(fd.get("id"), finalQty)
          .then(function (result) {
            if (!result || result.skipped) return;
            if (result.wasClamped) return;
            window.location.href = "/checkout";
          })
          .catch(function (err) {
            alert((err && err.message) || "Could not process Buy Now");
          })
          .finally(function () {
            var currentVariant = (product.variants || []).find(function (x) {
              return String(x.id) === String(sid.value);
            });
            buyNowBtn.disabled = !(currentVariant && currentVariant.available);
          });
      });
    }

    var recSize = "";
    var sfRoot = root.querySelector("[data-sf-overlay]");
    var sfSubmit = root.querySelector("[data-sf-submit]");

    function zeusMapToAvailableChartSize(rows, target, fallback) {
      var order = ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL"];
      var targetIdx = order.indexOf(zeusSizeFinderCanonical(target));
      if (targetIdx < 0) targetIdx = order.indexOf(zeusSizeFinderCanonical(fallback));
      if (targetIdx < 0) targetIdx = order.length - 1;
      if (!rows || !rows.length) return fallback || target;
      var available = [];
      for (var ri = 0; ri < rows.length; ri++) {
        var k = zeusSizeFinderCanonical(rows[ri].size);
        var idx = order.indexOf(k);
        if (idx >= 0) available.push({ idx: idx, size: rows[ri].size });
      }
      if (!available.length) return fallback || target;
      for (var ai = 0; ai < available.length; ai++) {
        if (available[ai].idx >= targetIdx) return available[ai].size;
      }
      return available[available.length - 1].size;
    }

    function zeusRecommendMenSize(height, weight, fit) {
      var sizes = ["S", "M", "L", "XL", "2XL", "3XL", "4XL"];
      function idx(s) {
        return sizes.indexOf(zeusSizeFinderCanonical(s));
      }
      function up(s) {
        var i = idx(s);
        if (i < 0) return "M";
        return sizes[Math.min(i + 1, sizes.length - 1)];
      }
      function down(s) {
        var i = idx(s);
        if (i < 0) return "M";
        return sizes[Math.max(i - 1, 0)];
      }

      var size;
      if (weight <= 58) size = "S";
      else if (weight <= 68) size = "M";
      else if (weight <= 80) size = "L";
      else if (weight <= 92) size = "XL";
      else if (weight <= 106) size = "2XL";
      else if (weight <= 122) size = "3XL";
      else size = "4XL";

      if (height >= 185 && weight >= 70) size = up(size);
      if (height >= 195 && weight >= 85) size = up(size);
      if (height <= 165 && weight <= 75) size = down(size);

      var bmi = weight / Math.pow(height / 100, 2);
      if (bmi >= 30 && idx(size) < idx("XL")) size = "XL";
      if (bmi >= 34 && idx(size) < idx("2XL")) size = "2XL";
      if (bmi >= 38 && idx(size) < idx("3XL")) size = "3XL";
      if (bmi >= 43) size = "4XL";

      if (normalizeZeusSfFit(fit) === "comfort") size = up(size);
      return sizes.includes(size) ? size : "M";
    }

    function zeusRecommendWomenSize(height, weight, fit) {
      var sizes = ["XS", "S", "M", "L", "XL", "2XL", "3XL"];
      function idx(s) {
        return sizes.indexOf(zeusSizeFinderCanonical(s));
      }
      function up(s) {
        var i = idx(s);
        if (i < 0) return "M";
        return sizes[Math.min(i + 1, sizes.length - 1)];
      }
      function down(s) {
        var i = idx(s);
        if (i < 0) return "M";
        return sizes[Math.max(i - 1, 0)];
      }

      var size;
      if (weight <= 48) size = "XS";
      else if (weight <= 56) size = "S";
      else if (weight <= 66) size = "M";
      else if (weight <= 78) size = "L";
      else if (weight <= 90) size = "XL";
      else if (weight <= 105) size = "2XL";
      else size = "3XL";

      if (height >= 170 && weight >= 55) size = up(size);
      if (height >= 178 && weight >= 65) size = up(size);
      if (height <= 155 && weight <= 65) size = down(size);

      var bmi = weight / Math.pow(height / 100, 2);
      if (bmi >= 29 && idx(size) < idx("L")) size = "L";
      if (bmi >= 33 && idx(size) < idx("XL")) size = "XL";
      if (bmi >= 37 && idx(size) < idx("2XL")) size = "2XL";
      if (bmi >= 42) size = "3XL";

      if (normalizeZeusSfFit(fit) === "comfort") size = up(size);
      return sizes.includes(size) ? size : "M";
    }

    function zeusRecommendSizeFromHeightWeight(rows, gender, height, weight, fit) {
      var g = String(gender || "").toLowerCase();
      if (g === "women") {
        if (height < 140 || height > 200 || weight < 35 || weight > 160)
          return null;
        return zeusMapToAvailableChartSize(
          rows,
          zeusRecommendWomenSize(height, weight, fit),
          "M"
        );
      }
      if (height < 140 || height > 220 || weight < 40 || weight > 220)
        return null;
      return zeusMapToAvailableChartSize(
        rows,
        zeusRecommendMenSize(height, weight, fit),
        "M"
      );
    }

    if (sfSubmit) {
      sfSubmit.addEventListener("click", function () {
        var hEl = root.querySelector("[id^='sfHeight-']");
        var wEl = root.querySelector("[id^='sfWeight-']");
        var fitEl = root.querySelector("[data-sf-fit], [id^='sfFit-']");
        var h = parseInt(hEl && hEl.value, 10);
        var w = parseInt(wEl && wEl.value, 10);
        var fitChoice = fitEl && fitEl.value;
        if (!h || !w) {
          alert(sfI18n.invalid || "Please enter valid height and weight");
          return;
        }

        var chartEl = root.querySelector("[data-zeus-size-chart]");
        var chart = null;
        if (chartEl && chartEl.textContent) {
          try {
            chart = JSON.parse(chartEl.textContent.trim());
          } catch (eChart) {
            chart = null;
          }
        }
        var rows = chart && chart.rows ? chart.rows : [];
        var g = chart && chart.gender ? String(chart.gender) : "";
        recSize = zeusRecommendSizeFromHeightWeight(rows, g, h, w, fitChoice);
        if (!recSize) {
          alert(sfI18n.invalid || "Please enter valid height and weight");
          return;
        }
        var rs = root.querySelector("[data-sf-size]");
        if (rs) rs.textContent = recSize;

        var f = root.querySelector("[data-sf-form]");
        var r = root.querySelector("[data-sf-result]");
        if (f) f.style.display = "none";
        if (r) {
          r.removeAttribute("hidden");
          r.classList.add("active");
        }
      });
    }

    var sfApply = root.querySelector("[data-sf-apply]");
    if (sfApply) {
      sfApply.addEventListener("click", function () {
        if (!recSize) return;
        var sizeRow = getPrimarySizeRow(root);
        if (!sizeRow) {
          if (sfRoot) sfRoot.classList.remove("active");
          syncModalBodyScroll();
          return;
        }
        var matchBtn = null;
        sizeRow.querySelectorAll("[data-zeus-opt]").forEach(function (b) {
          if (!matchBtn && zeusSizeFinderMatchesButton(b, recSize))
            matchBtn = b;
        });
        if (matchBtn) {
          sizeRow.querySelectorAll("[data-zeus-opt]").forEach(function (b) {
            b.classList.remove("active");
            b.setAttribute("aria-pressed", "false");
          });
          matchBtn.classList.add("active");
          matchBtn.click();
        }
        if (sfRoot) sfRoot.classList.remove("active");
        syncModalBodyScroll();
      });
    }
  }

  function boot() {
    document.querySelectorAll(".zeus-product-main").forEach(init);
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", function (e) {
    var r =
      e.target &&
      e.target.querySelector &&
      e.target.querySelector(".zeus-product-main");
    if (r) {
      delete r.dataset.zeusProductBound;
      init(r);
    }
  });

  if (typeof window !== "undefined") {
    window.initZeusProductMainNode = init;
  }
})();
